import { render, staticRenderFns } from "./formbuilderLogsWidget.vue?vue&type=template&id=3459ddaa&scoped=true"
import script from "./formbuilderLogsWidget.vue?vue&type=script&lang=js"
export * from "./formbuilderLogsWidget.vue?vue&type=script&lang=js"
import style0 from "./formbuilderLogsWidget.vue?vue&type=style&index=0&id=3459ddaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459ddaa",
  null
  
)

export default component.exports